import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React, { useState } from "react";
import "../../../Sass/Common.scss";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/CloseIcon.svg";
import warning_with_man from "../../../Assets/Image/warning_with_man.png";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "../../../Components/Common/PrimaryIcon";
import { useSelector } from "react-redux";
import BillingDialog from "../BillingDialog";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    background: `url(${warning_with_man}) 150px center no-repeat`,
    backgroundSize: "contain",
    top: "50px",
    position: "relative",
    height: "400px",
    display: "flex",
    "&>div": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      [theme.breakpoints.down("460")]: {
        padding: "30px 0px",
      },
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
          // [theme.breakpoints.down("600")]: {
          //   fontSize: "1rem !important",
          // },
        },
      },
      "&>div": {
        [theme.breakpoints.down("450")]: {
          width: "85% !important",
        },
        "&>h3": {
          color: "black",
          [theme.breakpoints.down("600")]: {
            fontSize: "1.313rem !important",
          },
          [theme.breakpoints.down("585")]: {
            fontSize: "1.2rem !important",
          },
          [theme.breakpoints.down("450")]: {
            fontSize: "1.1rem !important",
          },
        },
        "&>h4": {
          marginTop: "10px",
          marginBottom: "15px",
          color: "black",
          [theme.breakpoints.down("575")]: {
            fontSize: "0.9rem !important",
          },
        },
      },
    },
    [theme.breakpoints.down("760")]: {
      backgroundSize: "75%",
      backgroundPosition: "left 100% top 38%",
    },
    [theme.breakpoints.down("700")]: {
      backgroundSize: "470px",
      backgroundPosition: "left 90% top 38%",
      // backgroundPosition: "left 145px top 22px",
    },
    [theme.breakpoints.down("530")]: {
      backgroundSize: "90%",
      backgroundPosition: "left 70% top 30%",
    },
    [theme.breakpoints.down("500")]: {
      backgroundSize: "90%",
      backgroundPosition: "left 100% top 20%",
    },
    [theme.breakpoints.down("450")]: {
      backgroundSize: "365px",
      backgroundPosition: "left 100% top 20%",
    },
    [theme.breakpoints.down("400")]: {
      backgroundSize: "100%",
      backgroundPosition: "left 100% top 0%",
    },
    [theme.breakpoints.down("375")]: {
      backgroundSize: "100%",
      backgroundPosition: "left 100% top 10%",
    },
    [theme.breakpoints.down("330")]: {
      backgroundSize: "100%",
      backgroundPosition: "left 100% top 15%",
    },
  },
  dialogActionBtn: {
    marginTop: "20px",
    justifyContent: "flex-start !important",
    marginLeft: "10px",
    "&>button": {
      width: "180px",
      height: "40px",
      borderRadius: "10px",
      fontSize: "18px",
    },
  },
  iconStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#FBC14D",
    },
  },
  iconDeleteStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
  },
  rsAlertIcon: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#E9514E",
      fillOpacity: "0.6",
    },
  },
  dialogWidth: {},
  DailogContainer: {
    "&>div": {
      "&>div": {
        height: "500px",
        maxWidth: "800px",
        borderRadius: "15px",
      },
    },
  },
  closeBtn: {
    cursor: "pointer",
  },
}));

const SubscriptionWaringDailog = (props) => {
  const classes = useStyle();
  const { open, setOpen } = props;
  const loginUserDetail = useSelector((state) => state.user);
  const [paymentDialog, setPaymentDialog] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        maxWidth={"sm"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.DailogContainer}
      >
        <Box display={"flex"} justifyContent={"end"} marginTop={"10px"}>
          <PrimaryIcon
            className={classes.closeBtn}
            height="15px"
            onClick={handleClose}
            icon={CloseIcon}
          />
        </Box>

        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              marginBottom={"25px"}
            ></Box>
            <>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-start"}
                justifyContent={"flex-start"}
                marginLeft={"10px"}
              >
                <Typography variant="h3" medium width={"80%"}>
                  You cannot complete this order as your subscription has now
                  ended.
                </Typography>

                <Typography variant="h4" regular>
                  {loginUserDetail?.loginUserDetail?.data?.data?.role !==
                  "nursing"
                    ? "To renew your Repeatsmart subscription, you need to pick a plan."
                    : "Please contact your pharmacy"}
                </Typography>
              </Box>
            </>
          </DialogContent>
        </Box>
        {loginUserDetail?.loginUserDetail?.data?.data?.role !== "nursing" && (
          <DialogActions className={classes.dialogActionBtn}>
            <Button
              variant="contained"
              onClick={() => {
                setPaymentDialog(true);
              }}
            >
              Subscribe now
            </Button>
          </DialogActions>
        )}
      </Dialog>
      {paymentDialog && (
        <BillingDialog open={paymentDialog} setOpen={setPaymentDialog} />
      )}
    </>
  );
};

export default SubscriptionWaringDailog;
